import React, { useState, useEffect } from 'react';
import './Gallery.css';

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadImages = async () => {
      const loadFrom = async (url) => {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Failed to load ${url}`);
        }

        const contentType = response.headers.get('content-type') || '';
        if (!contentType.includes('application/json')) {
          throw new Error(`${url} did not return JSON`);
        }

        return response.json();
      };

      try {
        const data = await loadFrom('/get-images.php');
        setImages(data);
      } catch {
        try {
          const fallbackData = await loadFrom('/gallery-images.json');
          setImages(fallbackData);
        } catch (error) {
          console.error('Error loading gallery images:', error);
        }
      } finally {
        setLoading(false);
      }
    };

    loadImages();
  }, []);

  return (
    <div className="gallery-page">
      <section className="page-hero">
        <div className="page-hero-overlay"></div>
        <div className="page-hero-content">
          <h1>Gallery</h1>
          <p>Moments from our journey of creating positive impact</p>
        </div>
      </section>

      <section className="gallery-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Work in Action</h2>
            <div className="section-line"></div>
            <p className="section-subtitle">
              Capturing the moments that define our mission and the communities we serve
            </p>
          </div>

          {loading ? (
            <div style={{ textAlign: 'center', padding: '50px' }}>
              <p>Loading gallery...</p>
            </div>
          ) : images.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '50px' }}>
              <p>No images found in gallery.</p>
            </div>
          ) : (
            <div className="gallery-grid">
              {images.map((image, index) => (
                <div key={index} className="gallery-item">
                  <img src={image.src} alt={image.alt} loading="lazy" />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Gallery;
